import type { EntityPermissionsMapper } from 'logic/permissions/EntityPermissionsMapper';
import EntityPermissionsMapperBinder from 'logic/permissions/EntityPermissionsMapper';

const supportedTypes = new Set(['dashboard', 'sigma_rule', 'event_procedure', 'event_procedure_step']);

const securityEntityPermissionsMapper: EntityPermissionsMapper = {
  mapForIdAndType(id: string, type: string): string | undefined {
    if (id.startsWith('graylog-security-views__') && supportedTypes.has(type)) return 'graylog_security:';

    return undefined;
  },
  mapForType(type: string): string | undefined {
    if (supportedTypes.has(type)) return `${type}s:`;

    return undefined;
  },
};

EntityPermissionsMapperBinder.register(securityEntityPermissionsMapper);

export default securityEntityPermissionsMapper;
